// extracted by mini-css-extract-plugin
export default {"subline":"subline-TuglI5fFsg6_l0G5YuX5"};